<template>
  <v-container>
    <v-card>
      <v-card-title>
        <span class="text-h6">Inventario</span>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="openDialog('add')">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="resources"
        item-value="id"
        dense
        class="elevation-1"
        :search="search"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Buscar"
            outlined
            dense
            class="mx-4 small-input"
          ></v-text-field>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon @click="openDialog('edit', item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Diálogo para agregar/editar -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>{{ dialogTitle }}</v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-text-field
              v-model="resource.name"
              label="Nombre"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="resource.description"
              label="Descripción"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="resource.brand"
              label="Marca"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="resource.part_number"
              label="Número de pieza"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="resource.stock"
              label="Stock"
              type="number"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="resource.stock_min"
              label="Stock mínimo"
              type="number"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="resource.stock_max"
              label="Stock máximo"
              type="number"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="resource.price"
              label="Precio"
              type="number"
              outlined
              dense
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" @click="saveResource">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" :z-index="3000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
  
  <script>
import axios from "@/plugins/axios.js";

export default {
  data() {
    return {
      search: "",
      dialog: false,
      dialogTitle: "",
      headers: [
        { text: "Nombre", value: "name" },
        { text: "Descripción", value: "description" },
        { text: "Marca", value: "brand" },
        { text: "Número de pieza", value: "part_number" },
        { text: "Stock", value: "stock" },
        { text: "Stock min", value: "stock_min" },
        { text: "Stock max", value: "stock_max" },
        { text: "Precio", value: "price" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      resources: [],
      resource: {
        id: null,
        name: "",
        description: "",
        brand: "",
        part_number: "",
        stock: 0,
        stock_min: 0,
        stock_max: 0,
        price: 0,
      },
      resourceTypes: ["Repuesto", "Mano de obra"],
      action: "", // 'add' o 'edit'
      overlay: false,
    };
  },
  mounted() {
    this.getResources();
  },
  methods: {
    getResources() {
      this.overlay = true;
      axios
        .get("/resources/getResources")
        .then((response) => {
          this.resources = [...response.data];
        })
        .catch((err) => {
          console.error("Error al obtener recursos:", err);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    openDialog(action, resource = null) {
      this.action = action;
      this.clearForm();
      if (this.action === "edit" && resource) {
        this.resource = { ...resource };
      }
      this.dialog = true;
      this.dialogTitle =
        action === "add" ? "Agregar Recurso" : "Editar Recurso";
    },
    saveResource() {
      if (!this.validateFields()) {
        alert("Por favor, completa todos los campos.");
        return;
      }
      this.overlay = true;
      if (this.action === "add") {
        this.createResource();
      } else {
        this.updateResource();
      }
    },
    validateFields() {
      return (
        this.resource.name && this.resource.description && this.resource.brand && this.resource.part_number && this.resource.stock && this.resource.stock_min && this.resource.stock_max && this.resource.price
      );
    },
    createResource() {
      axios
        .post("/resources/register", {
          name: this.resource.name,
          description: this.resource.description,
          brand: this.resource.brand,
          part_number: this.resource.part_number,
          stock: this.resource.stock,
          stock_min: this.resource.stock_min,
          stock_max: this.resource.stock_max,
          price: this.resource.price,
        })
        .then(() => {
          this.getResources();
          this.dialog = false;
          this.clearForm();
        })
        .catch((err) => {
          console.error("Error al registrar recurso:", err);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    updateResource() {
      axios
        .put(`/resources/update`, {
          id : this.resource.id,
          name: this.resource.name,
          description: this.resource.description,
          brand: this.resource.brand,
          part_number: this.resource.part_number,
          stock: this.resource.stock,
          stock_min: this.resource.stock_min,
          stock_max: this.resource.stock_max,
          price: this.resource.price,
        })
        .then(() => {
          this.getResources();
          this.dialog = false;
          this.clearForm();
        })
        .catch((err) => {
          console.error("Error al actualizar recurso:", err);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    clearForm() {
      this.resource = {
        id: null,
        name: "",
        description: "",
        brand: "",
        part_number: "",
        stock: 0,
        stock_min: 0,
        stock_max: 0,
        price: 0,
      };
    },
  },
};
</script>
  
  <style scoped>
.small-input .v-input__control {
  height: 30px !important;
  font-size: 9pt;
  padding: 4px 8px !important;
}
.small-input .v-label {
  font-size: 0.75rem;
  top: -6px;
}
</style>
  